import React from "react";

import styles from "./LoadingIcon.module.scss";
import { ReactComponent as Icon } from "assets/misc/loading.svg";

const LoadingIcon = () => <Icon className={styles.animated} />;

export default LoadingIcon;
